module.exports = {
  datetime: {
    year: '年',
    month: '月',
    fullMonth: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    shortMonth: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
    weekday: ['日', '一', '二', '三', '四', '五', '六'],
    format: {
      year: 'yyyy年',
      month: 'MM月',
      date: 'yyyy-MM-dd',
      datetime: 'yyyy-MM-dd hh:mm:ss',
      time: 'hh:mm:ss'
    }
  }
};



/** WEBPACK FOOTER **
 ** ./src/lang/zh-cn/datetime.js
 **/